export enum LeadFormTitle {
   Banner = 'Complete Your Profile',
   Forum = 'Connect with IITians and NEET Experts',
   Registration = 'Complete Your Profile',
   CMS = 'Complete Your Profile'
}
export enum LeadFormType {
   Banner = 1,
   Forum = 2,
   Registration = 3,
   CMS = 4
}
